import { Link } from 'react-router-dom';
import { ChevronRight, type LucideIcon } from 'lucide-react';

// Página "hub" reutilizable (PR-UX1): presenta sub-áreas poco acopladas como
// tarjetas que navegan a páginas independientes ya existentes. El sidebar solo
// muestra la entrada del hub; las sub-opciones viven aquí. Para sub-áreas con
// datos acoplados se usa el patrón de pestañas (ver GymPage), no este.

export interface HubCard {
  to: string;
  icon: LucideIcon;
  title: string;
  description: string;
  /** testid de la tarjeta. Default: `hub-card-<path sin barra inicial>`. */
  testid?: string;
}

interface HubPageProps {
  subtitle?: string;
  cards: HubCard[];
}

// El título de la página lo pinta el Header (AdminLayout.PAGE_TITLES), igual que
// el resto de páginas admin; el hub solo aporta el subtítulo descriptivo y la
// rejilla de tarjetas. Así evitamos duplicar el encabezado.
export default function HubPage({ subtitle, cards }: HubPageProps) {
  return (
    <div className="space-y-6">
      {subtitle && <p className="text-text-secondary text-sm">{subtitle}</p>}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {cards.map(({ to, icon: Icon, title: cardTitle, description, testid }) => (
          <Link
            key={to}
            to={to}
            data-testid={testid ?? `hub-card-${to.slice(1)}`}
            className="card hover:border-gold-primary/50 transition-colors flex flex-col gap-3 group"
          >
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-lg bg-bg-elevated flex items-center justify-center text-gold-primary shrink-0">
                <Icon size={20} />
              </span>
              <h2 className="font-oswald text-base uppercase tracking-wider text-white flex-1">
                {cardTitle}
              </h2>
              <ChevronRight
                size={16}
                className="text-text-secondary/50 group-hover:text-gold-primary transition-colors"
              />
            </div>
            <p className="text-text-secondary text-xs">{description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
